import React from 'react'

function Footer() {
    return (
        <footer>
                Created by Joseph Barajar
        </footer>
    )
}

export default Footer